import { ApolloError } from '@apollo/client'
import { useCallback, useState } from 'react'

export const QUESTION_ALREADY_IN_USE_ERROR = 'Some questions already in use for different entities'

type UseQuestionsSubmitErrorReturn = {
  submitQuestionError: string | null
  setSubmitQuestionError: (error: string | null) => void
  handleServerError: (error: unknown) => void
}

export const useQuestionsSubmitError = (): UseQuestionsSubmitErrorReturn => {
  const [submitQuestionError, setSubmitQuestionError] = useState<string | null>(null)

  const handleServerError = useCallback((error: unknown) => {
    if (error instanceof Error) {
      setSubmitQuestionError(error.message || QUESTION_ALREADY_IN_USE_ERROR)
      return
    }

    if (error && typeof error === 'object' && 'graphQLErrors' in error) {
      const graphQLError = (error.graphQLErrors as ApolloError['graphQLErrors'])?.[0]?.message
      setSubmitQuestionError(graphQLError || QUESTION_ALREADY_IN_USE_ERROR)
      return
    }

    setSubmitQuestionError(QUESTION_ALREADY_IN_USE_ERROR)
  }, [])

  return {
    submitQuestionError,
    setSubmitQuestionError,
    handleServerError,
  }
}
